export default "__VITE_ASSET__w8tHUfpq__"